import Home from '../pages/Home'

import '../css/Opening.css'

const Opening = () => {
  return (
    <div>
      <div className="opening-content">
        <div className="welcome">Welcome to my website!</div>
      </div>
      <Home />
    </div>
  )
}

export default Opening
